import { Fabric, Theme } from "@nuorder/components";
import { CreateRollupAssortmentDialog } from "containers/folders/containers/space-manager/components/dialogs/create-rollup-assortment";
import { DATATEST } from "constants/integration";
import { GridApi } from "ag-grid-community";
import { IAllocationDimension } from "helpers/allocation-dimension";
import { formatMessage } from "lib/globalize-util";
import IconButton from "material-ui/IconButton";
import IconMenu from "material-ui/IconMenu";
import MenuItem from "material-ui/MenuItem";
import MoreVertIcon from "material-ui/svg-icons/navigation/more-vert";
import * as React from "react";
import { IDoorTotals } from "reducers/collection";
import { ExportRollup } from "./export-rollup";
import { IExportParams } from "constants/product-collection";

interface IProps {
    onExport: (params: IExportParams) => void;
    collectionExport: any;
    onClearCollectionExport: () => void;
    onUpdateCollectionAttribute: (id: string, prop: string, value: any, reset?: boolean) => void;
    allocationDimensions: IAllocationDimension[];
    gridApi: GridApi;
    doorTotals: IDoorTotals;
    doorTotalsFiltered: IDoorTotals;
    collectionDriveItem: nuorder.folder.v1.Item;
    verticalAssortmentsEnabled: boolean;
}

export const ProductRollupActionsView: React.FunctionComponent<IProps> = ({
    onExport,
    allocationDimensions,
    collectionExport,
    onClearCollectionExport,
    gridApi,
    doorTotals,
    doorTotalsFiltered,
    collectionDriveItem,
    onUpdateCollectionAttribute,
    verticalAssortmentsEnabled,
}) => {
    const [exportDialogOpen, setExportDialogOpen] = React.useState<boolean>(false);
    const [isEditRollupOpen, setIsEditRollupOpen] = React.useState<boolean>(false);
    const handleOpenEditDialog = () => {
        setIsEditRollupOpen(true);
    };

    const handleCloseEditDialog = () => {
        setIsEditRollupOpen(false);
    };

    const handleOpenExportDialog = () => {
        setExportDialogOpen(true);
        onClearCollectionExport();
    };

    const handleCloseExportDialog = () => {
        setExportDialogOpen(false);
        onClearCollectionExport();
    };

    const handleSuccesEditRollup = () => {
        handleCloseEditDialog();
        location.reload();
    };

    return (
        <>
            <IconMenu
                iconButtonElement={
                    <IconButton data-test={DATATEST.ROLLUP.ROLLUPT_KABOB_BTN}>
                        <MoreVertIcon />
                    </IconButton>
                }
                anchorOrigin={{ horizontal: "right", vertical: "top" }}
                targetOrigin={{ horizontal: "right", vertical: "top" }}
                useLayerForClickAway={true}
            >
                <MenuItem
                    key="edit-rollup"
                    onClick={handleOpenEditDialog}
                    primaryText={formatMessage("Edit Rollup")}
                    data-test={DATATEST.ROLLUP.EDIT_MENU_ITEM}
                />
                <MenuItem
                    key="all"
                    onClick={handleOpenExportDialog}
                    primaryText={formatMessage("Export Rollup")}
                    data-test={DATATEST.ROLLUP.EXPORT_MENU_ITEM}
                />
            </IconMenu>
            {exportDialogOpen && (
                <ExportRollup
                    allocationDimensions={allocationDimensions}
                    collectionExport={collectionExport}
                    onCancel={handleCloseExportDialog}
                    onConfirm={onExport}
                    gridApi={gridApi}
                    doorTotals={doorTotals}
                    doorTotalsFiltered={doorTotalsFiltered}
                />
            )}
            {isEditRollupOpen && (
                <Theme>
                    <Fabric>
                        <CreateRollupAssortmentDialog
                            onClose={handleCloseEditDialog}
                            isEditRollupOpen={true}
                            collectionDriveItem={collectionDriveItem}
                            hideViewRollup={true}
                            parentId={collectionDriveItem.parent}
                            onSuccesEditRollup={handleSuccesEditRollup}
                            verticalAssortmentsEnabled={verticalAssortmentsEnabled}
                        />
                    </Fabric>
                </Theme>
            )}
        </>
    );
};
